<template>
  <v-container
    fluid
  >
    <v-row
      v-if="!ordered"
    >
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="4"
      >
        <v-card>
          <v-card-title>
            Einheitlich im Auftritt – persönlich in der Passform
          </v-card-title>
          <v-card-subtitle>
            Kameradinnen und Kameraden,
            hier könnt ihr eure persönliche Dienstkleidung auswählen. Die Ausstattung erfolgt einheitlich und individuell nach Bedarf. Pro Person wird ein Satz ausgegeben; die finale Ausgabe erfolgt nach Antrag und Freigabe durch den Kleiderwart. Danke für euren Einsatz und eure Mithilfe.
          </v-card-subtitle>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="new_order.last_name"
                label="Vor- und Nachname"
                :rules="[rules.required]"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                dense
                v-model="new_order.email"
                label="E-Mail"
                :rules="[rules.required, rules.email]"
                outlined
              ></v-text-field>
              <v-autocomplete
                v-model="new_order.station"
                label="Ortsfeuerwehr"
                :items="ortsfeuerwehrs"
                item-text="text"
                item-value="value"
                :rules="[rules.required]"
                outlined
                disabled
                hide-details
                dense
              ></v-autocomplete>
              <v-textarea
                class="mt-4"
                v-model="new_order.comment"
                label="Anmerkungen"
                outlined
                dense
                hide-details
                maxlength="255"
              ></v-textarea>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text v-if="new_order.allocations.length > 0">
            <strong>Bestellzusammenfassung</strong>

            <v-list dense>
              <v-list-item
                v-for="allocation in new_order.allocations"
                :key="allocation.product_id"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ getProductName(allocation.product_id) }}
                  </v-list-item-title>

                  <v-list-item-subtitle>
                    Größe: {{ allocation.size || '—' }}
                    <span v-if="allocation.quantity">
            | Menge: {{ allocation.quantity }}
          </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>

          <v-card-text v-else class="grey--text text--darken-1">
            Noch keine Artikel ausgewählt.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!valid || new_order.allocations.length === 0"
              @click="order()"
            >
              Bestellung abschicken
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        v-if="$store.state.shop.products"
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="8"
      >
            <v-container
              fluid
            >
              <v-row>
                <v-col
                  v-for="(item, index) in $store.state.shop.products.filter(p => p.active)"
                  :key="index"
                  class="pt-0"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="6"
                  lg="4"
                  xl="3"
                >
                  <ShopItem
                    :item="item"
                    @add-item="addItem(item, $event)"
                    @remove-item="removeItem(item)"
                  ></ShopItem>
                </v-col>
              </v-row>
            </v-container>
      </v-col>
    </v-row>
    <v-row
      v-if="ordered"
    >
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-title>
            Vielen Dank für deine Bestellung!
          </v-card-title>
          <v-card-subtitle>
            Der Kleiderbeauftragte meldet sich bei dir, sobald deine Bestellung geprüft und freigegeben wurde. Du hast eine Bestätigung per E-Mail bekommen.
          </v-card-subtitle>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="reset()"
            >
              Neue Bestellung aufgeben
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import ShopItem from "./ShopItem.vue";

export default {
  name: "ShopOrder",
  components: { ShopItem },
  data: () => ({
    valid: false,
    ordered: false,
    new_order: {
      email: '',
      first_name: '',
      last_name: '',
      station: 'GBS',
      comment: '',
      allocations: []
    },
    ortsfeuerwehrs: [
      { text: "OFW Garbsen", value: "GBS" },
      { text: "OFW Berenbostel", value: "BBS" },
      { text: "OFW Heitlingen", value: "HEI" },
      { text: "STE", value: "STE" },
      { text: "HOR", value: "HOR" },
      { text: "MEY", value: "MEY" },
      { text: "SRI", value: "SRI" },
      { text: "OUE", value: "OUE" },
      { text: "FRI", value: "FRI" },
      { text: "OOE", value: "OOE" }
    ],
    rules: {
      required: value => !!value || 'Dieses Feld ist erforderlich.',
      email: value => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return pattern.test(value) || 'Ungültige E-Mail-Adresse.'
      }
    }
  }),
  methods: {
    reset(){
      this.new_order.email = ""
      this.new_order.first_name = ""
      this.new_order.last_name = ""
      this.new_order.station = "GBS"
      this.new_order.comment = ""
      this.new_order.allocations = []
      this.ordered = false
      this.valid = false
    },
    getProductName(productId) {
      const product = this.$store.state.shop.products.find(
        p => p.id === productId
      );
      return product ? product.name : "Unbekannter Artikel";
    },
    order(){
      // Umwandeln
      const payload = {
        email: this.new_order.email,
        first_name: this.new_order.first_name,
        last_name: this.new_order.last_name,
        station: this.new_order.station,
        comment: this.new_order.comment,
        allocations: this.new_order.allocations.map(a => ({
          variant_id: a.variant_id,
          amount: a.quantity
        }))
      };
      this.$store.dispatch("update", {
        payload_type: "POST",
        payload: payload,
        context: "/shop/allocations",
      });
      // this.new_order.first_name = ''
      // this.new_order.last_name = ''
      // this.new_order.email = ''
      // this.new_order.comment = ''
      // this.new_order.allocations = []
      this.ordered = true
    },
    addItem(item, payload) {
      const index = this.new_order.allocations.findIndex(
        a => a.product_id === payload.product_id
      );

      if (index !== -1) {
        // existiert schon → ersetzen (reactive!)
        this.$set(this.new_order.allocations, index, payload);
      } else {
        // neu hinzufügen
        this.new_order.allocations.push(payload);
      }
    },
    removeItem(item) {
      const index = this.new_order.allocations.findIndex(
        a => a.product_id === item.id
      );

      if (index !== -1) {
        this.new_order.allocations.splice(index, 1);
      }
    }
  }
};
</script>




<style scoped>

</style>